import React from 'react';
import CrudPage from '../../components/CrudPage';
import { forestApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'forestId' },
  { header: 'Forest Name', field: 'forestName' },
  { header: 'Location', field: 'location' },
  { header: 'Total Trees', field: 'totalTrees' },
  { header: 'Active', field: 'isActive', render: (v) => v ? 'Yes' : 'No' },
];

const formFields = [
  { name: 'forestName', label: 'Forest Name', type: 'text', required: true },
  { name: 'location', label: 'Location', type: 'text' },
  { name: 'description', label: 'Description', type: 'textarea' },
  { name: 'totalTrees', label: 'Total Trees', type: 'number' },
  { name: 'imageUrl', label: 'Image URL', type: 'text' },
  { name: 'isActive', label: 'Active', type: 'checkbox' },
];

const ForestPage = () => (
  <CrudPage
    title="Forests"
    subtitle="Manage EcoVest forests"
    api={forestApi}
    columns={columns}
    formFields={formFields}
    idField="forestId"
    searchField="forestName"
  />
);

export default ForestPage;
